import { render, staticRenderFns } from "./exchangeMgmt.vue?vue&type=template&id=7c98f296"
import script from "./exchangeMgmt.vue?vue&type=script&lang=js"
export * from "./exchangeMgmt.vue?vue&type=script&lang=js"
import style0 from "./exchangeMgmt.vue?vue&type=style&index=0&id=7c98f296&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports